/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React, { useRef, useState } from 'react';
import { SelectLink as SelectLinkKit } from '@veeam/components';

import type { FC } from 'react';
import type { SelectLinkProps } from '@veeam/components';

import { usePopstate } from '../../hooks/use-popstate';

export const SelectLink: FC<SelectLinkProps> = (props) => {
    const [isModalActive, setIsModalActive] = useState(false);
    const closeModalFn = useRef(null);

    const { activate, deactivate } = usePopstate(
        () => {
            setIsModalActive(false);
            closeModalFn.current?.();
        },
        isModalActive
    );

    const handleActivate = () => {
        setIsModalActive(true);
        activate();
    };

    const handleDeactivate = () => {
        setIsModalActive(false);
        deactivate();
    };

    return (
        <SelectLinkKit
            {...props}
            onClick={(e) => {
                handleActivate();

                props.onClick?.(e);
            }}
            renderModal={(renderModalParams) => {
                closeModalFn.current = renderModalParams.deactivate;

                return props.renderModal({
                    ...renderModalParams,
                    isActive: isModalActive,
                    deactivate: () => {
                        handleDeactivate();

                        renderModalParams.deactivate();
                    },
                });
            }}
        />
    );
};
